import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WindowContents } from "@app/cp/shared/enums/windowContents";

@Component( {
    selector: 'cp-attachments-window',
    templateUrl: './attachments-window.component.html',
    styleUrls: [ './attachments-window.component.scss' ]
} )
export class AttachmentsWindowComponent implements OnInit {

    constructor() {
    }

    @Input() title: number;
    @Input() compData: any;
    @Input() embedScr: any;
    @Input() iframeScr: any;
    @Input() imgScr: any;
    @Input() attachmentType: any;

    @Output() closed = new EventEmitter<boolean>();
    public childTitle: string;
    public contentTypes = WindowContents;

    ngOnInit() {
    }

    setTitle( title ) {
        this.childTitle = title;
    }

    closeWindow() {
        this.closed.emit( true );
    }

    cancelEvent() {
        this.closed.emit( false );
    }

}
